import { render, staticRenderFns } from "./YourRights.vue?vue&type=template&id=30cceadc&"
import script from "./YourRights.vue?vue&type=script&lang=js&"
export * from "./YourRights.vue?vue&type=script&lang=js&"
import style0 from "./YourRights.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports